import React, { FC, PropsWithChildren, useEffect, useState } from "react";
import styled from "styled-components";

import { DEFAULT_ASPECT_RATIO } from "../constants";
import { useEmbedParametersContext } from "../contexts/EmbedParametersContext";
import { isValidAspectRatio } from "../helpers/commonUtils";
import { usePlayerStore } from "../store/usePlayerStore";

export const resolveAspectRatio = (
  aspectRatio: string | undefined,
  streamAspectRatio: string | undefined
): string => {
  const ratio =
    (aspectRatio === "auto" ? streamAspectRatio : aspectRatio) ||
    DEFAULT_ASPECT_RATIO.LANDSCAPE;

  if (!isValidAspectRatio(ratio)) {
    console.warn("Invalid aspect ratio", ratio);
    return DEFAULT_ASPECT_RATIO.LANDSCAPE;
  }

  return ratio;
};

const AspectRatioWrapper = styled.div<{ paddingTop?: string }>`
  display: block;
  width: 100%;
  ${({ paddingTop }) => (paddingTop ? `padding-top: ${paddingTop};` : "")}
`;

type Props = PropsWithChildren & React.HTMLAttributes<HTMLDivElement>;

export const PreviewAspectRatio: FC<Props> = ({ children, ...attrs }) => {
  const { useStoreState } = usePlayerStore();
  const aspectRatio = useStoreState.aspectRatio();
  const { stretch } = useEmbedParametersContext();
  // We render children after the paddingTop is set, because otherwise child elements "drop" when paddingTop has been added
  const [paddingTop, setPaddingTop] = useState<string>();

  useEffect(() => {
    if (stretch) {
      setPaddingTop("100%");
    } else {
      const [aspectRatioWidth, aspectRatioHeight] = (
        aspectRatio || DEFAULT_ASPECT_RATIO.LANDSCAPE
      ).split(":");
      setPaddingTop((+aspectRatioHeight / +aspectRatioWidth) * 100 + "%"); // padding-top percentage is based on parent element width
    }
  }, [aspectRatio, stretch]);

  return (
    <AspectRatioWrapper paddingTop={paddingTop} {...attrs}>
      {paddingTop && children}
    </AspectRatioWrapper>
  );
};
